module.exports = __webpack_public_path__ + "img/card-b6.749591ca.png";